import { createFileRoute, Link } from '@tanstack/react-router';
import { BrandMark } from '../components/layout/BrandMark';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="min-h-svh bg-background px-4 py-10 sm:py-14">
      <div className="mx-auto max-w-2xl">
        <div className="mb-6">
          <BrandMark />
        </div>
        <div className="rounded-2xl border border-border bg-card p-6 sm:p-8">
          <h1 className="mb-6 text-2xl font-semibold tracking-tight">Integritetspolicy</h1>

          <div className="space-y-4 text-sm leading-relaxed">
            <p>
              <span className="text-muted-foreground">Senast uppdaterad:</span> 2025-06-01
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">
              1. Vem ansvarar för dina uppgifter?
            </h2>
            <p>
              Budgie är en personlig budgetapp som drivs för privat bruk. Appen hanterar ekonomiska
              uppgifter som du själv väljer att dela via bankintegration (Enable Banking) eller
              manuell import.
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">
              2. Vilka uppgifter behandlas?
            </h2>
            <ul className="list-disc space-y-1 pl-5">
              <li>Kontouppgifter: IBAN, kontonamn, saldo</li>
              <li>Transaktioner: datum, belopp, beskrivning, motpart</li>
              <li>Inloggningsuppgifter: e-postadress och hashade lösenord</li>
            </ul>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">
              3. Hur samlas uppgifterna in?
            </h2>
            <p>
              Via Enable Bankings API efter att du gett ditt uttryckliga samtycke genom bankens
              säkra autentisering (BankID eller liknande). Du kan även importera transaktioner
              manuellt via CSV-filer.
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">
              4. Varför behandlar vi uppgifterna?
            </h2>
            <p>
              Enbart för att visa din ekonomiska översikt, kategorisera transaktioner och hjälpa dig
              hantera din budget. Uppgifterna delas aldrig med tredjeparter och används inte för
              marknadsföring.
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">
              5. Hur lagras uppgifterna?
            </h2>
            <p>
              Uppgifterna lagras i en krypterad databas. Åtkomst kräver inloggning med e-post och
              lösenord. Bankuppgifter hämtas via säker anslutning till Enable Banking.
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">6. Dina rättigheter</h2>
            <p>
              Du kan när som helst radera ditt konto och alla tillhörande uppgifter. Du kan också
              återkalla bankåtkomst via{' '}
              <a
                href="https://enablebanking.com/data-sharing-consents/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                Enable Bankings konsenthantering
              </a>
              .
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">7. Kontakt</h2>
            <p>
              Vid frågor om dina personuppgifter, kontakta oss via e-post:{' '}
              <a href="mailto:privacy@strengthara.com" className="text-primary hover:underline">
                privacy@strengthara.com
              </a>
            </p>
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground">
            ← Tillbaka till inloggning
          </Link>
        </div>
      </div>
    </div>
  );
}
